import { productsSlice } from '../slices/products';
import type { Product } from '@interfaces/general';
import { useAppDispatch, useAppSelector } from '..';

export const useProductsFromStore = () => {
  return useAppSelector((state) => state.products);
};

export const useProductActions = () => {
  const dispatch = useAppDispatch();

  const initProducts = (products: Product[]) => dispatch(productsSlice.actions.initProducts(products));

  const addProduct = (product: Product) => dispatch(productsSlice.actions.addProduct(product));

  const updateProduct = (product: Product) => dispatch(productsSlice.actions.updateProduct(product));

  const deleteProduct = (productId: { id: string }) => dispatch(productsSlice.actions.deleteProduct(productId));

  return { initProducts, addProduct, updateProduct, deleteProduct };
};
